export const UserHasPermission = (actionId) => {
    return (window.optima?.user?.ActionIDs?.includes(actionId)) || (window.SelfieSettings?.settings?.user?.actions[actionId] === actionId)
}

export const PermissionsActions = {
    AllowSetFolioAsPending: 202,
    EditReceiptPrice: 189,
    AccessToCharge: 188,
    AccessToIssueInvoice: 187,
    AccessToSendConfirmation: 185,
    AccessSendEmailPage: 184,
    AccessMessagingPage: 183,
    EditReservationColor: 182,
    ViewFamilyAndFriends: 181,
    AccessSaveCardAuthorization: 180,
    CancelReservation: 179,
    CheckOutReservation: 178,
    CheckInReservation: 177,
    ViewShortReservation: 176,
    EditETA_ETD: 175,
    EditPricingType: 174,
    EditPrice: 173,
    AllowSelectionOfRestrictedProducts: 172,
    ViewRoomPlannedMaintenancePopup: 164,
    AccessPricesPopup: 163,
    AccessRestrictionsPopup: 162,
    ViewGuestInHouse: 161,
    ViewGroupReservation: 160,
    ViewReservation: 159,
    SearchReservations: 158,
    PaymentPerformRefund: 151,
    EditFieldName: 207,
    AddFieldName: 208,
    EditFieldValue: 209,
    AddFieldValue: 210,
    EditShortDescription: 211,
    EditLongDescription: 212,
    DeleteContent: 213,
    RemoveManualRestrictions: 233,
    ToggleRoomLock: 234,
    CreateOOO: 235,
    CreateOOS: 236,
    DeleteOOO: 237,
    DeleteOOS: 238,
    EditOOO: 239,
    EditOOS: 240,
    DeleteReservation: 241,
    AllowSaveWithoutRequiredGuarantee: 243,
    EditHotelDateParameters: 250,
    ViewStatisticSources: 255,
    ViewPriceGroups: 256,
    ViewClassificationCategories: 257,
}
